import ContentfulImage from 'components/WebsiteImage';
import ContentfulInPageFeatures from 'components/Contentful/ContentfulInPageFeatures';
import ContentfulRichText from 'components/RichText/ContentfulRichText';
import ContentfulEmbedCode from 'components/Contentful/ContentfulEmbedCode';
import ContentfulWistiaVideo from 'components/Core/WistiaVideo';
import ContentfulTable from 'components/Table';
import ContentfulSocialProofComponent from 'components/Contentful/ContentfulSocialProofComponent';
import ContentfulStaticComponent from 'components/Contentful/ContentfulStaticComponent';
import ContentfulAccordion from 'components/Contentful/ContentfulAccordion';
import ContentfulInlineMarketingForm from './Wrappers/ContentfulInlineMarketingFormColumnWrapper';
import ContentfulCallToAction from './Wrappers/ContentfulCallToActionColumnWrapper';
import ContentfulCardsBlock from './Wrappers/ContentfulCardsBlockColumnWrapper';
import ContentfulCard from './Wrappers/ContentfulColumnCardWrapper';

const ComponentMap = {
  ContentfulCallToAction,
  ContentfulCardsBlock,
  ContentfulCard,
  ContentfulEmbedCode,
  ContentfulImage,
  ContentfulInlineMarketingForm,
  ContentfulInPageFeatures,
  ContentfulRichText,
  ContentfulStaticComponent,
  ContentfulWistiaVideo,
  ContentfulAccordion,
  ContentfulTable,
  ContentfulSocialProofComponent,
};

export default ComponentMap;
